// Curated palette of distinguishable badge colors: [background, text]
const PARTY_PALETTE: [string, string][] = [
	['#1e40af', '#dbeafe'],
	['#047857', '#d1fae5'],
	['#b91c1c', '#fee2e2'],
	['#7c3aed', '#ede9fe'],
	['#c2410c', '#ffedd5'],
	['#0f766e', '#ccfbf1'],
	['#be185d', '#fce7f3'],
	['#4338ca', '#e0e7ff'],
	['#a16207', '#fef3c7'],
	['#15803d', '#dcfce7'],
	['#9333ea', '#f3e8ff'],
	['#0369a1', '#e0f2fe'],
	['#dc2626', '#fecaca'],
	['#059669', '#a7f3d0'],
	['#d97706', '#fde68a'],
	['#2563eb', '#bfdbfe'],
	['#7c2d12', '#fed7aa'],
	['#115e59', '#99f6e4'],
	['#86198f', '#fae8ff'],
	['#1e3a5f', '#bdd5ea'],
	['#374151', '#e5e7eb'],
	['#78350f', '#fde68a'],
	['#581c87', '#e9d5ff'],
	['#064e3b', '#a7f3d0'],
];

// Well-known Nigerian party brand colors
const KNOWN_PARTIES: Record<string, [string, string]> = {
	APC: ['#1e40af', '#dbeafe'],
	PDP: ['#b91c1c', '#fee2e2'],
	LP: ['#047857', '#d1fae5'],
	NNPP: ['#7c2d12', '#fed7aa'],
	ADC: ['#7c3aed', '#ede9fe'],
	APGA: ['#15803d', '#dcfce7'],
	SDP: ['#c2410c', '#ffedd5'],
	YPP: ['#0f766e', '#ccfbf1'],
};

const hashCode = (str: string): number => {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i);
		hash |= 0;
	}
	return Math.abs(hash);
};

export const getPartyColor = (shortName: string): { bg: string; text: string } => {
	const known = KNOWN_PARTIES[shortName.toUpperCase()];
	if (known) return { bg: known[0], text: known[1] };
	const idx = hashCode(shortName) % PARTY_PALETTE.length;
	return { bg: PARTY_PALETTE[idx][0], text: PARTY_PALETTE[idx][1] };
};
